import { PRODUCT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { isReadOnlyProductProperty } from '../utils/identifiers';
import { useAdditionalPropertyValues } from './useAdditionalPropertyValues';
export const useIsReadOnlyProductProperty = (objectTypeId, propertyDefinition) => {
  const {
    data,
    loading
  } = useAdditionalPropertyValues({
    hs_pricing_model: 'hs_pricing_model',
    hs_bundle_type: 'hs_bundle_type'
  }, {
    skip: objectTypeId !== PRODUCT_TYPE_ID
  });
  if (loading) {
    return true;
  }
  return isReadOnlyProductProperty({
    objectTypeId,
    property: propertyDefinition,
    pricingModel: data === null || data === void 0 ? void 0 : data.hs_pricing_model,
    bundleType: data === null || data === void 0 ? void 0 : data.hs_bundle_type
  });
};